import React from "react";
import { toast } from "react-toastify";
import { steps } from "../ModalAutoRenew";
import Spinner from "../../../../components/shared/spinner/Spinner";

const AutoRenewStop = ({
  onClose,
  student,
  user,
  handleAutoRenewal,
  handleCurrentStep,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const autoRenewStop = async () => {
    try {
      setIsLoading(true);

      await handleAutoRenewal({
        subId: student?.subscription?.id,
        isEnabled: false,
        coachId: user?.id,
      });
      setIsLoading(false);
      toast.success("Auto-renewal stopped successfully.");
      onClose();
    } catch (error) {
      toast.error("Failed to stop auto-renew. Please try again later.");
    }
  };

  return (
    <>
      <div className="text-2xl font-bold text-black mt-2">
        Do you want to remove {student?.firstName}{" "}
        <span className="uppercase">{student?.lastName?.slice(0, 1)}</span>.
        from auto-renew?
      </div>

      <div className="text-base text-grayTrue700 mt-2">
        The subscription will end at the current billing period.{" "}
        {student?.firstName} can always resubscribe manually if needed
      </div>

      <button
        disabled={isLoading}
        onClick={(e) => {
          e.stopPropagation();
          autoRenewStop();
        }}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnPrimary500 mt-4"
      >
        {isLoading ? (
          <Spinner color="primary500" size="sm" />
        ) : (
          "Yes, stop auto-renewal"
        )}
      </button>

      <button
        disabled={isLoading}
        onClick={onClose}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnGray100 mt-2"
      >
        Nevermind
      </button>
    </>
  );
};

export default AutoRenewStop;
